$(() => {
  const initSlider = (carousel) => {
    const indicators = carousel.querySelectorAll("[data-carousel-indicators] li")
    const arrows = carousel.querySelectorAll("[data-carousel-arrows] a")
    const itemsWrapper = carousel.querySelector("[data-carousel-slider]")

    if (!carousel || !itemsWrapper || !(indicators || arrows)) {
      return
    }

    const items = itemsWrapper.querySelectorAll("[data-carousel-item]")
    const isFade = carousel.hasAttribute("data-carousel-fade")
    const autoplayInterval = parseInt(carousel.getAttribute("data-carousel-autoplay"), 10)

    let currentIndex = 0
    let autoplayTimer = null

    function goToSlide(index) {
      currentIndex = (index + items.length) % items.length

      if (isFade) {
        items.forEach((item, i) => {
          item.classList.toggle("active", i === currentIndex)
        })
      } else {
        itemsWrapper.scrollTo({
          left: $(items).eq(currentIndex).width() * currentIndex,
          top: 0,
          behavior: "smooth"
        })
      }

      indicators.forEach((item, i) => {
        item.classList.toggle("active", i === currentIndex)
      })
    }

    if (isFade) {
      goToSlide(0)
    } else {
      const config = {threshold: 0.5}
      let observer = new IntersectionObserver(function (entries) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const current = $(entry.target).index()
            indicators.forEach((item, index) => {
              item.classList.toggle("active", index === current)
            })
          }
        })
      }, config)
      items.forEach((item) => observer.observe(item))
    }

    if (!isNaN(autoplayInterval) && autoplayInterval > 0) {
      function startAutoplay() {
        autoplayTimer = setInterval(() => goToSlide(currentIndex + 1), autoplayInterval)
      }
      function stopAutoplay() {
        clearInterval(autoplayTimer)
      }

      startAutoplay()
      carousel.addEventListener("mouseenter", stopAutoplay)
      carousel.addEventListener("mouseleave", startAutoplay)
    }

    $(indicators).on("click", function() {
      goToSlide($(this).index())
      if (!isNaN(autoplayInterval) && autoplayInterval > 0) {
        clearInterval(autoplayTimer)
        autoplayTimer = setInterval(() => goToSlide(currentIndex + 1), autoplayInterval)
      }
    })

    $(arrows).on("click", function(event) {
      event.preventDefault()
      const direction = $(this).data("direction")

      if (isFade) {
        goToSlide(direction === 'next' ? currentIndex + 1 : currentIndex - 1)
        if (!isNaN(autoplayInterval) && autoplayInterval > 0) {
          clearInterval(autoplayTimer)
          autoplayTimer = setInterval(() => goToSlide(currentIndex + 1), autoplayInterval)
        }
      } else {
        let sliderShift = $(itemsWrapper).scrollLeft()
        let sliderWidth = $(itemsWrapper).width()

        if (direction === 'next') {
          $(items).each((index, item) => {
            if (sliderWidth < $(item).offset().left + $(item).width()) {
              itemsWrapper.scrollTo({
                left: sliderShift + $(item).offset().left - 30,
                top: 0,
                behavior: "smooth"
              })
              return false
            }
          })
        } else {
          $(items).each((index, item) => {
            if ($(item).offset().left > 0 && index !== 0 && $(items).eq(index - 1).offset().left < 0) {
              itemsWrapper.scrollTo({
                left: sliderShift - sliderWidth + $(items).eq(index - 1).offset().left + $(items).eq(index - 1).width() + 30,
                top: 0,
                behavior: "smooth"
              })
              return false
            }
          })
        }
      }
    })
  }

  const carousels = document.querySelectorAll("[data-carousel]");

  if (carousels && carousels.length) {
    carousels.forEach((carousel) => {
      initSlider(carousel)
    })
  }
});
